import type { UI } from '@/v2/types';
import { useMemo } from 'react';

import { PartialPropertiesContent } from '@/v2/services/bff/getDestinationPage/getDestinationPage';
import enrichThemePropertiesWithDestination from './enrichThemePropertiesWithDestination';

export type UseEnrichPropertiesProps = {
  destinationOrTheme: UI.Destination | null;
  propertiesContent: PartialPropertiesContent[] | null;
  themeDestinations: UI.Destination[] | null;
};

export type EnrichedProperty = PartialPropertiesContent & {
  destination?: UI.Destination | null;
  theme?: UI.Destination;
};

const useEnrichProperties = ({
  destinationOrTheme,
  propertiesContent,
  themeDestinations,
}: UseEnrichPropertiesProps): EnrichedProperty[] => {
  return useMemo(() => {
    if (!destinationOrTheme || !propertiesContent) {
      return [];
    }

    // If Theme => merge each property with appropriate destination
    if (destinationOrTheme.theme) {
      return enrichThemePropertiesWithDestination({
        theme: destinationOrTheme,
        properties: propertiesContent,
        themeDestinations: themeDestinations,
      });
    }

    // If Destination => just merge same destination into each property
    return propertiesContent.map((property) => ({
      ...property,
      destination: destinationOrTheme,
    }));
  }, [themeDestinations, destinationOrTheme, propertiesContent]);
};

export default useEnrichProperties;
